import React from 'react';
import { CheckIcon, ShieldCheckIcon, ClockIcon, CreditCardIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
interface PricingSectionProps {
  variant?: 'compact' | 'full';
}
export function PricingSection({
  variant = 'full'
}: PricingSectionProps) {
  const checkoutUrlKit = 'https://payments.vantapro.shop/cart/45305126846566:1';
  const checkoutUrlExtra = 'https://payments.vantapro.shop/cart/45305094963302:1';
  const isCompact = variant === 'compact';
  return <section id={isCompact ? undefined : 'compra'} className="py-8 md:py-10 px-4 bg-[#daeaf8] text-gray-900 scroll-mt-10" data-id="element-182">
      <div className="max-w-5xl mx-auto" data-id="element-183">
        {/* Scarcity & Urgency - only on full variant */}
        {!isCompact && <div className="bg-[#0a1a3a] rounded-xl p-4 text-center mb-6 shadow-2xl border-2 border-[#112244] text-white" data-id="element-184">
            <h3 className="text-lg md:text-xl font-bold mb-2" data-id="element-185">
              ⏰ El precio de lanzamiento termina en:
            </h3>
            <CountdownTimer showLabels={true} className="mb-2 text-green-400" data-id="element-186" />
            <p className="text-base font-medium mb-2" data-id="element-187">
              Después sube{' '}
              <span className="text-red-500 font-black" data-id="element-188">$10.000 ARS</span> y no
              vuelve a bajar.
            </p>

            <div className="max-w-sm mx-auto bg-white/10 rounded-lg p-2 mt-3" data-id="element-189">
              <div className="flex justify-between text-xs font-bold mb-1 uppercase" data-id="element-190">
                <span data-id="element-191">Cupos al precio de lanzamiento</span>
                <span data-id="element-192">Quedan pocos</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3 mb-1 overflow-hidden" data-id="element-193">
                <div className="h-3 rounded-full" style={{
              width: '74%',
              background: 'linear-gradient(to right, #22c55e, #eab308, #ef4444)'
            }} data-id="element-194"></div>
              </div>
              <div className="text-right text-xs font-bold text-yellow-400" data-id="element-195">
                74% de los cupos tomados
              </div>
            </div>
          </div>}

        <div className="text-center mb-4" data-id="element-196">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-1" data-id="element-197">
            Elegí tu Kit
          </h2>
          <p className="text-sm text-gray-600 font-medium" data-id="element-198">
            Todas las opciones incluyen los 3 bonos exclusivos
          </p>
        </div>

        {/* COMPACT: Stacked rectangular cards */}
        {isCompact && <div className="flex flex-col gap-4 max-w-lg mx-auto" data-id="element-199">
            {/* Card 1 */}
            <div className="bg-white text-gray-900 rounded-2xl p-4 shadow-lg border-2 border-blue-200 text-center" data-id="element-200">
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-201">
                <span className="text-xl" data-id="element-202">📘</span>
                <h3 className="text-base font-black text-gray-900" data-id="element-203">
                  Kit Completo
                </h3>
              </div>
              <p className="text-gray-500 font-medium text-xs mb-2" data-id="element-204">
                6 libros + 3 bonos
              </p>
              <div className="mb-3" data-id="element-205">
                <span className="text-sm text-gray-400 line-through font-bold" data-id="element-206">
                  $49.990
                </span>
                <div data-id="element-207">
                  <span className="text-3xl font-black text-blue-600" data-id="element-208">
                    $19.990
                  </span>
                  <span className="text-xs font-bold text-gray-400 ml-1" data-id="element-209">
                    ARS
                  </span>
                </div>
              </div>
              <a href={checkoutUrlKit} target="_blank" rel="noopener noreferrer" className="block w-full bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold py-2.5 rounded-xl shadow-md transition-all duration-200 uppercase" data-id="element-210">
                🔥 ACCEDER AHORA AL KIT
              </a>
            </div>

            {/* Card 2 */}
            <div className="bg-white text-gray-900 rounded-2xl p-4 shadow-lg border-2 border-yellow-400 text-center relative" data-id="element-211">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-212">
                <span className="bg-yellow-400 text-gray-900 font-black px-3 py-0.5 rounded-full text-[11px] uppercase tracking-wider shadow-sm whitespace-nowrap" data-id="element-213">
                  ✨ MÁS ELEGIDO ✨
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 mb-1 mt-1" data-id="element-214">
                <span className="text-xl" data-id="element-215">🎁</span>
                <h3 className="text-base font-black text-gray-900" data-id="element-216">
                  Kit + Material Extra
                </h3>
              </div>
              <p className="text-gray-500 font-medium text-xs mb-2" data-id="element-217">
                6 libros + 3 bonos + extras
              </p>
              <div className="mb-3" data-id="element-218">
                <span className="text-sm text-gray-400 line-through font-bold" data-id="element-219">
                  $59.990
                </span>
                <div data-id="element-220">
                  <span className="text-3xl font-black text-orange-500" data-id="element-221">
                    $24.990
                  </span>
                  <span className="text-xs font-bold text-gray-400 ml-1" data-id="element-222">
                    ARS
                  </span>
                </div>
              </div>
              <a href={checkoutUrlExtra} target="_blank" rel="noopener noreferrer" className="block w-full bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold py-2.5 rounded-xl shadow-md transition-all duration-200 uppercase btn-pulse" data-id="element-223">
                🏆 KIT COMPLETO + MATERIAL EXTRA
              </a>
            </div>
          </div>}

        {/* FULL: Side by side square cards */}
        {!isCompact && <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-224">
            {/* Card 1 */}
            <div className="bg-white text-gray-900 rounded-2xl p-5 shadow-2xl flex flex-col relative border-2 border-blue-200" data-id="element-225">
              <div className="text-center mb-3" data-id="element-226">
                <h3 className="text-xl font-black text-gray-900 mb-1 flex items-center justify-center gap-2" data-id="element-227">
                  <span className="text-2xl" data-id="element-228">📘</span> Kit Completo
                </h3>
                <p className="text-gray-600 font-medium text-sm" data-id="element-229">
                  6 libros + 3 bonos
                </p>
              </div>
              <div className="text-center mb-4" data-id="element-230">
                <span className="text-lg text-gray-400 line-through font-bold block" data-id="element-231">
                  $49.990
                </span>
                <div className="flex items-center justify-center gap-1" data-id="element-232">
                  <span className="text-4xl font-black text-blue-600" data-id="element-233">
                    $19.990
                  </span>
                  <span className="text-sm font-bold text-gray-500" data-id="element-234">ARS</span>
                </div>
              </div>
              <ul className="space-y-2 mb-4 flex-1" data-id="element-235">
                <li className="flex items-start" data-id="element-236">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-237" />
                  <span className="font-medium text-gray-700 text-sm" data-id="element-238">
                    6 Libros de Actividades
                  </span>
                </li>
                <li className="flex items-start" data-id="element-239">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-240" />
                  <span className="font-medium text-gray-700 text-sm" data-id="element-241">
                    3 Bonos Exclusivos
                  </span>
                </li>
                <li className="flex items-start" data-id="element-242">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-243" />
                  <span className="font-medium text-gray-700 text-sm" data-id="element-244">
                    Formato PDF de alta calidad
                  </span>
                </li>
                <li className="flex items-start" data-id="element-245">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-246" />
                  <span className="font-medium text-gray-700 text-sm" data-id="element-247">
                    Acceso Inmediato por Drive
                  </span>
                </li>
              </ul>
              <a href={checkoutUrlKit} target="_blank" rel="noopener noreferrer" className="w-full bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-3 px-5 rounded-xl shadow-[0_4px_14px_0_rgba(249,115,22,0.39)] transition-all duration-200 uppercase text-center block" data-id="element-248">
                🔥 ACCEDER AHORA AL KIT
              </a>
            </div>

            {/* Card 2 - Highlighted */}
            <div className="bg-white text-gray-900 rounded-2xl p-5 shadow-[0_0_30px_rgba(234,179,8,0.3)] flex flex-col relative border-2 border-yellow-400" data-id="element-249">
              <div className="absolute -top-4 left-0 right-0 flex justify-center" data-id="element-250">
                <span className="bg-yellow-400 text-gray-900 font-black px-3 py-1 rounded-full text-xs uppercase tracking-widest shadow-md" data-id="element-251">
                  ✨ MÁS ELEGIDO ✨
                </span>
              </div>
              <div className="text-center mb-3 mt-2" data-id="element-252">
                <h3 className="text-xl font-black text-gray-900 mb-1 flex items-center justify-center gap-2" data-id="element-253">
                  <span className="text-2xl" data-id="element-254">🎁</span> Kit + Material Extra
                </h3>
                <p className="text-gray-600 font-medium text-sm" data-id="element-255">
                  6 libros + 3 bonos + tarjetas de estimulación y juegos extras
                </p>
              </div>
              <div className="text-center mb-4" data-id="element-256">
                <span className="text-lg text-gray-400 line-through font-bold block" data-id="element-257">
                  $59.990
                </span>
                <div className="flex items-center justify-center gap-1" data-id="element-258">
                  <span className="text-4xl font-black text-orange-500" data-id="element-259">
                    $24.990
                  </span>
                  <span className="text-sm font-bold text-gray-500" data-id="element-260">ARS</span>
                </div>
                <p className="text-xs font-bold text-orange-500 mt-1 bg-orange-100 inline-block px-2 py-0.5 rounded-full" data-id="element-261">
                  Para quienes quieren ir un paso más
                </p>
              </div>
              <ul className="space-y-2 mb-4 flex-1" data-id="element-262">
                <li className="flex items-start" data-id="element-263">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-264" />
                  <span className="font-bold text-gray-900 text-sm" data-id="element-265">
                    Todo lo del Kit Completo
                  </span>
                </li>
                <li className="flex items-start" data-id="element-266">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-267" />
                  <span className="font-medium text-gray-700 text-sm" data-id="element-268">
                    Tarjetas de Estimulación Extra
                  </span>
                </li>
                <li className="flex items-start" data-id="element-269">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-270" />
                  <span className="font-medium text-gray-700 text-sm" data-id="element-271">
                    Juegos Sensoriales Adicionales
                  </span>
                </li>
                <li className="flex items-start" data-id="element-272">
                  <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-273" />
                  <span className="font-medium text-gray-700 text-sm" data-id="element-274">
                    Acceso Inmediato por Drive
                  </span>
                </li>
              </ul>
              <a href={checkoutUrlExtra} target="_blank" rel="noopener noreferrer" className="w-full bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-3 px-5 rounded-xl shadow-[0_4px_14px_0_rgba(249,115,22,0.39)] transition-all duration-200 uppercase text-center block btn-pulse" data-id="element-275">
                🏆 KIT COMPLETO + MATERIAL EXTRA
              </a>
            </div>
          </div>}

        {/* Trust Badges */}
        <div className="mt-8 flex flex-wrap justify-center gap-6 md:gap-10" data-id="element-276">
          <div className="flex items-center gap-2 text-gray-700" data-id="element-277">
            <ShieldCheckIcon className="w-6 h-6 text-green-500" data-id="element-278" />
            <span className="font-bold text-sm" data-id="element-279">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700" data-id="element-280">
            <ClockIcon className="w-6 h-6 text-blue-500" data-id="element-281" />
            <span className="font-bold text-sm" data-id="element-282">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700" data-id="element-283">
            <CheckIcon className="w-6 h-6 text-yellow-500" data-id="element-284" />
            <span className="font-bold text-sm" data-id="element-285">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700" data-id="element-286">
            <CreditCardIcon className="w-6 h-6 text-blue-500" data-id="element-287" />
            <span className="font-bold text-sm" data-id="element-288">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}